import React from 'react';
import { Typography } from '@material-ui/core';

export default function User() {
    return (
    <Typography > Coming soon </Typography>
        )
}